import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import LocalizedImage from "../LocalizedImage/LocalizedImage";
import { useTranslation } from "react-i18next";

const OneOasis = () => {
  const { t } = useTranslation();

  return (
    <ImageLoader>
      <Container>
        <Row className="section">
          <Col md={4}>
            <AnimateOnScroll animationType="slideRight">
              <h2
                dangerouslySetInnerHTML={{ __html: t("oneoasis_main_title") }}
              />
              <p>{t("oneoasis_main_p")}</p>
            </AnimateOnScroll>
          </Col>
          <Col md={8}>
            <AnimateOnScroll animationType="slideLeft">
              <img
                src="/images/award4.jpg"
                alt="One Oasis"
                className="fullimg"
              />
            </AnimateOnScroll>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="section">
              <AnimateOnScroll animationType="slideUp">
                <LocalizedImage
                  src="/images/map.jpg"
                  alt="One Oasis"
                  className="fullimg"
                />
              </AnimateOnScroll>
            </div>
          </Col>
        </Row>
        <Row className="section border">
          <Row className="bottom-padding">
            <Col md={4} className="d-flex flex-column justify-content-center">
              <AnimateOnScroll animationType="slideRight">
                <p>{t("oneoasis_hengqin_p")}</p>
              </AnimateOnScroll>
            </Col>

            <Col md={8} className="d-flex flex-column justify-content-center">
              <AnimateOnScroll animationType="slideLeft">
                <img src="/images/M8.jpg" alt="One Oasis" className="fullimg" />
              </AnimateOnScroll>
            </Col>
          </Row>
          <Row>
            <Col md={8} className="d-flex flex-column justify-content-center">
              <AnimateOnScroll animationType="slideRight">
                <img src="/images/M7.jpg" alt="One Oasis" className="fullimg" />
              </AnimateOnScroll>
            </Col>
            <Col md={4}></Col>
          </Row>
        </Row>
      </Container>
    </ImageLoader>
  );
};

export default OneOasis;
